<div class="row g-0 text-center text-sm-start align-items-center mb-4 mt-4">
    <ng-container *ngIf="totalRegistros > 0">
        <div class="col-sm-6">
            <div>
                <p class="mb-sm-0 text-muted" [innerHTML]="utilityService.getRangeLabel(pagina, registros, totalRegistros)">
                </p>
            </div>
        </div>
        <div class="col-sm-6">
            <ngb-pagination [collectionSize]="totalRegistros" [(page)]="pagina" [pageSize]="registros" [maxSize]="7" [rotate]="true" (pageChange)="pageChangeTable($event)" aria-label="Custom pagination" class="pagination justify-content-end mb-0">
                <ng-template ngbPaginationPrevious>Anterior</ng-template>
                <ng-template ngbPaginationNext>Siguiente</ng-template>
            </ngb-pagination>
        </div>
    </ng-container>

</div>
